/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ActionFieldError } from "@core/shared/utils/normalize-action-error";
import { normalizeActionError } from "@core/shared/utils/normalize-action-error";
import { userAtom } from "@framework/config/atoms";
import { Endpoint } from "@mongez/http";
import { GenericObject } from "@mongez/reinforcements";
import { useLocation } from "@remix-run/react";

export type ActionResponse<DataType = any> = {
  status: number;
  error?: string;
  errors?: ActionFieldError[];
  data: DataType;
  isOK: boolean;
};

export function useBaseAction<DataType = any>(path: string) {
  return async (
    body?: FormData | GenericObject,
  ): Promise<ActionResponse<DataType>> => {
    try {
      const response = await new Endpoint().post(path, body);

      if (response.data?.user) {
        userAtom.update(response.data.user);
      }

      return {
        isOK: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      const failure = normalizeActionError(error);

      return {
        isOK: false,
        status: failure.status,
        error: failure.error,
        errors: failure.errors,
        data: failure.data as DataType,
      };
    }
  };
}

export function useAction<DataType = any>(path?: string) {
  const location = useLocation();

  return useBaseAction<DataType>((path || location.pathname) + "/action");
}
